import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import 'react';
import defaultStyles from './styles/Field.module.scss.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { isObject } from '../../utils/is.js';

const ID_SUFFIX = '_input';
const Label = ({
  showColon,
  requiredSymbol = {
    position: 'end'
  },
  htmlFor,
  label,
  required,
  theme,
  idSuffix = ID_SUFFIX
}) => {
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const symbolPosition = isObject(requiredSymbol) ? requiredSymbol.position : 'start';
  const symbolNode = required && !!requiredSymbol && /*#__PURE__*/jsx("strong", {
    className: styles.label_symbol,
    children: "*"
  });
  const colon = showColon ? ':' : '';
  const isSymbolNode = symbolNode ? /*#__PURE__*/jsxs(Fragment, {
    children: [" ", symbolNode]
  }) : null;
  return label ? /*#__PURE__*/jsxs("label", {
    className: styles.label,
    htmlFor: htmlFor && `${htmlFor}${idSuffix}`,
    "aria-labelledby": htmlFor && `${htmlFor}${idSuffix}`,
    children: [symbolPosition !== 'end' && isSymbolNode, label, symbolPosition === 'end' && isSymbolNode, colon]
  }) : null;
};
Label.displayName = 'Label';

export { Label };
